/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../../../fw/Grid.react.js';
import {ParentTemplate} from '../../box-utils/ParentTemplate.react.js';
import {relayWrap} from '../../box-utils/ParentBox.react.js';
import {Link} from 'react-router';

import {viewWithDataGetPrimaryData} from '../../box-utils/PrimaryData';
import Error from './Error.react.js';
import {sendError} from '../../../app/errorDisplayer';
import BoxDecorator from '../../box-utils/BoxDecorator.react';
import {getAutoIcon} from './HTMLTemplate.react';
import * as FeatureFlags from '../../../../common/util/FeatureFlags.ts';
import {Tooltip, OverlayTrigger} from 'react-bootstrap';
import {FormattedMessage} from 'react-intl';
import * as BrowserPermission from "../../../BrowserPermission";
import {safeJSONparse} from "../../../../common/util/safeJSONparse";

// eslint-disable-next-line max-params
export function renderPreviewDefault(content, column, item, url, columnMapping) {
    if (!content) {
        content = "-";
        if (columnMapping.type === "number") {
            content = "10";
        } else if (columnMapping.type === "money") {
            content = "1000.00";
        } else if (columnMapping.type === "boolean") {
            content = "X";
        } else if (columnMapping.type === "email") {
            content = "contact@example.com";
        }
    }

    return (<span className="dativeryValue">{content}</span>);
}


class JSONTable extends ParentTemplate {

    static handlerName = "json-table";

    static propTypes = {
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    getUrl = (item, column) => {
        if (!column || column === "dativery") {
            return;
        }

        return this.getUrlInternal(item, column);
    };

    getUrlInternal = (item, column) => {
        if (!column) {
            return;
        }

        let {addon} = this.props.viewWithData;
        addon = safeJSONparse(addon);

        if (addon && addon['links'] && addon['links'][item.key]) {
            let url = addon['links'][item.key];

            if (url[column]) {
                return url[column].href;
            }
        }
    };

    getIcon() {
        let icon = getAutoIcon(this.props.viewWithData);

        if (icon) {
            return icon;
        }

        return "fa-list";
    }

	getServiceName() {
		let {entityDef} = this.props.viewWithData;

		if (entityDef && entityDef.name) {
			return entityDef.name;
		}
	}

	// eslint-disable-next-line max-params
    renderPreview(content, column, item, url, columnMapping) {
        return renderPreviewDefault(content, column, item, url, columnMapping);
    }

	renderDativeryLinks(column, item) {
		let out = [];

		let url;
		if (FeatureFlags.hasFeatureFlag(FeatureFlags.FEATURE_DASHBOARD, BrowserPermission.getPermissionObject())) {
			url = this.getUrlInternal(item, 'dativery');
			if (url) {
				/* absolute links are href, others or <Link /> */
				if (url.startsWith("http://") || url.startsWith("https://")) {
					out.push(<a href={url} key="2" target="_blank">
						<span className="fa fa-puzzle-piece fa-flip-horizontal"></span>
					</a>);
				} else {
					out.push(<Link key="2" to={url}>
						<span className="fa fa-puzzle-piece fa-flip-horizontal"></span>
					</Link>);
				}
				out.push(<span key="3">&nbsp; &nbsp;</span>);
			}
		}

		url = this.getUrlInternal(item, '*');
		if (this.props.isPreview && !url) {
			url = "#";
		}
		if (url) {
			let tooltip = this.getTooltip(item);

			out.push(
				<OverlayTrigger  key="1" overlay={tooltip} placement="top">
					<a href={url} key="1" target="_blank"><span className="fa fa-search"></span></a>
				</OverlayTrigger>
			);
		}

		return out;
	}

	getTooltip(item) {
		let appName = 'CRM';

		if (this.props.isPreview) {
			return (<Tooltip id="jsonTableTooltip"><FormattedMessage defaultMessage="Link to connected application detail page" id="jsonTable.previewTooltip" values={{app: appName}}/></Tooltip>);
		}

		if (item && item.channel) {
			return (<Tooltip id="jsonTableTooltip"><FormattedMessage defaultMessage="Open {app} detail" id="jsonTable.openTooltip" values={{app: item.channel}}/></Tooltip>);
		}

		return (<Tooltip id="jsonTableTooltip"><FormattedMessage defaultMessage="Open in application detail" id="jsonTable.openDefaultTooltip" /></Tooltip>);
	}

    render() {
        let {view} = this.props.viewWithData;
        let {entityViewDef} = view;
        let data = viewWithDataGetPrimaryData(this.props.viewWithData);

        if (!data) {
            data = [];
        }

        let templateArray = [];

        if (entityViewDef) {
            try {
                templateArray = safeJSONparse(entityViewDef['template']);
            } catch (e) {
                sendError(e);
            }
        } else if (this.props.viewWithData.entityDef && this.props.viewWithData.entityDef.allFieldDefs) {
            templateArray = this.props.viewWithData.entityDef.allFieldDefs.edges.map(({node}) => node['realId']);
        }

        /* sometime we can get null */
        if (!templateArray) {
            templateArray = [];
        }

        /* we want to render two rows of data */
        if (this.props.isPreview) {
            if (this.props.viewWithData.entityDef && this.props.viewWithData.entityDef.allFieldDefs) {
                let exampleRow = {};

                for (let field of this.props.viewWithData.entityDef.allFieldDefs.edges) {
                    if (field.node.exampleData) {
                        exampleRow[field.node.realId] = field.node.exampleData;
                    }
                }

                data = [
                    {
                        key: '1',
                        ...exampleRow
                    },
                    {
                        key: '2',
                        ...exampleRow
                    }
                ];
            } else {
                data = [{key: '1'}, {key: '2'}];
            }
        }


        let templateColumns = {};

        for (let column of templateArray) {
            /**
             * backward compatiblity (it used to be array only)
             */
            if (typeof column === "string") {
                column = {
                    id: column
                };
            }

            templateColumns[column.id] = {};
        }

        /* add artificial item dativery */
        templateColumns['dativery'] = {
            render: this.renderDativeryLinks.bind(this)
        };

        try {
            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <small className="jsonTable">
						<Grid columns={templateColumns}
							getUrl={this.getUrl}
							list={data}
							metadata={this.getMetaData()}
							render={this.props.isPreview ? this.renderPreview : null}
						/>
					</small>
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(JSONTable);
